import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { v4 as uuidv4 } from 'uuid';
import { Loader } from '../../../components/common';
import { mergeClassNames } from '../../../utils';
import SortLabel from './SortLabel';
import TableRow from './TableRow';
const Table = ({ loading, columns, rows, onSelect, sortParams, onSortChange, }) => {
    const tableRows = [];
    if (rows) {
        rows.forEach((thisRow) => {
            const key = uuidv4();
            tableRows.push(_jsx(TableRow, { row: thisRow, onClick: onSelect }, key));
        });
    }
    return (_jsxs("div", { className: "w-full overflow-x-auto", children: [_jsxs("table", { className: "w-full divide-y divide-gray-200", children: [_jsx("thead", { children: _jsx("tr", { children: columns.map(({ id, width, align, sortable, text }) => {
                                return (_jsx("th", { className: mergeClassNames(width && `w-${width}`, `whitespace-nowrap px-3 py-2 bg-gray-50 text-xs text-gray-600 uppercase font-normal text-${align}`), children: sortable
                                        ? (_jsx(SortLabel, { sortName: id, selectedSortName: sortParams?.name, sortOrder: sortParams?.order, onSortChange: onSortChange, className: `w-full ${align === 'left' ? 'justify-start' : 'justify-end'}`, children: text }))
                                        : text }, id));
                            }) }) }), !loading && _jsx("tbody", { className: "bg-white divide-y divide-gray-200", children: tableRows })] }), loading && (_jsx("div", { className: "align-middle pt-10 h-96", children: _jsx(Loader, {}) }))] }));
};
export default Table;
